module.exports = __webpack_public_path__ + "img/word_1.dc1367e2.png";